import React, { useContext, useMemo } from "react";
import { StateContext } from "../../../StateProvider";
import { useNavigate } from "react-router-dom";
import "./DogServicesPricing.css";
import trainingPageIcon from "../../../../assets/Store/Services/Training/trainingPageIcon.png";
import { BackButton } from "../../../Utilities/components/Buttons";
import LetsGetStarted from "../../../Utilities/components/LetsGetStarted";
import Footer from "../../../Footer";

/* -------------------- helpers -------------------- */
function normalizeCatalog(raw) {
  var out = {};
  if (!raw) return out;
  for (var k in raw) {
    if (!Object.prototype.hasOwnProperty.call(raw, k)) continue;
    var arr = raw[k];
    if (Array.isArray(arr) && arr.length > 0) {
      var s = arr[0];
      var key = s && s.serviceName ? String(s.serviceName).toLowerCase() : String(k).toLowerCase();
      out[key] = s;
    }
  }
  return out;
}

function currency(n) {
  var val = Number(n);
  if (!isFinite(val)) return "—";
  return "$" + val.toFixed(0);
}

function SectionCard(props) {
  return (
    <section className="service-section">
      <h2 className="section-title">{props.title}</h2>
      {props.children}
    </section>
  );
}

/* ---- Membership price strip ---- */
function MembershipPriceChips(props) {
  var tiers = props.tiers || {};
  var onClick = props.onClick; // added
  var rows = [
    { key: "club", label: "Pawsible Club", tier: tiers.club, className: "tier-club" },
    { key: "plus", label: "Pawsible Plus", tier: tiers.plus, className: "tier-plus" }
  ];
  var chips = [];
  var i;
  for (i = 0; i < rows.length; i++) {
    var r = rows[i];
    if (r.tier && isFinite(Number(r.tier.price))) {
      chips.push(
        <span
          key={r.key}
          className={"member-price-chip " + r.className}
          title={r.label}
          onClick={() => onClick && onClick(r.key)}
        >
          <span className="member-price-chip__label">{r.label}</span>
          <span className="member-price-chip__price">{currency(r.tier.price)}</span>
          <span className="member-price-chip__per">/ mo</span>
        </span>
      );
    }
  }
  return <div className="member-price-strip">{chips}</div>;
}

function MembershipBenefitMatrix() {
    var navigate = useNavigate();
    var rows = [
    { benefit: "Member Savings", club: "10%", plus: "20%", isBadge: true },
    { benefit: "Community Events", club: "✓", plus: "✓" },
    { benefit: "Health & Grooming Checks", club: "✓", plus: "✓" },
    { benefit: "Personalized Report Cards", club: "✓", plus: "✓" },
    { benefit: "Concierge & Text Support", club: "✓", plus: "✓" },
    { benefit: "Nail & Teeth Care", club: "—", plus: "✓" },
    { benefit: "Priority Booking Access", club: "—", plus: "✓" },
    { benefit: "Birthday Treat & Perks", club: "—", plus: "✓" },
    { benefit: "Daycare Shuttle (1st Month)", club: "—", plus: "✓" },
  ];

  var list = [];
  for (var i = 0; i < rows.length; i++) {
    var r = rows[i];
    list.push(
      <li key={i} className="benefit-row" onClick={(key) => {navigate("/store/membership"); window.scrollTo(0, 0);}}>
        <span className="benefit-text">{r.benefit}</span>
        {r.isBadge ? (
          <>
            <span className="membership-rect-badge club-badge">{r.club}</span>
            <span className="membership-rect-badge plus-badge">{r.plus}</span>
          </>
        ) : (
          <>
            <span className={`benefit-val tier-club${r.club === "—" ? " hyphen" : ""}`}>{r.club}</span>
            <span className={`benefit-val tier-plus${r.plus === "—" ? " hyphen" : ""}`}>{r.plus}</span>
          </>
        )}
      </li>
    );
  }

  return (
    <div className="benefit-matrix-wrap">
      <div className="matrix-header">
        <span />
        <span className="matrix-col">Club</span>
        <span className="matrix-col">Plus</span>
      </div>
      <ul className="benefit-matrix">{list}</ul>
    </div>
  );
}

/* ----- Vertical grooming price cards (mobile-first) ----- */
function GroomingVertical(props) {
  var priceBySize = props.priceBySize || {};
  var order = ["small", "medium", "large", "x-large"];
  var SIZE_HINTS = {
    small: "~ 10 lbs",
    medium: "11 ~ 30 lbs",
    large: "31 ~ 50 lbs",
    "x-large": "51 lbs ~"
  };

  var out = [];
  for (var i = 0; i < order.length; i++) {
    var size = order[i];
    var gp = priceBySize[size];
    if (!gp) continue;
    out.push(
      <div key={size} className="groom-card-vertical">
        <div className="groom-card-head">
          <div className="groom-size">
            {size.charAt(0).toUpperCase() + size.slice(1)}{" "}
            <span className="size-hint-inline no-cap">({SIZE_HINTS[size]})</span>
          </div>
        </div>

        <div className="groom-lines">
          <div className="groom-line">
            <span className="groom-label">Nail</span>
            <span className="groom-price">{currency(gp.nail)}</span>
          </div>
          <div className="groom-line">
            <span className="groom-label">Bath</span>
            <span className="groom-price">{currency(gp.bath)}</span>
          </div>
          <div className="groom-line">
            <span className="groom-label">Touch-up</span>
            <span className="groom-price">{currency(gp.touchup)}</span>
          </div>
          <div className="groom-line">
            <span className="groom-label">Full Groom</span>
            <span className="groom-price">{currency(gp.grooming)}</span>
          </div>
          <div className="groom-line">
            <span className="groom-label">Teeth Cleaning</span>
            <span className="groom-price">{currency(gp.teeth)}</span>
          </div>
        </div>
      </div>
    );
  }
  return <div className="groom-vertical-wrap">{out}</div>;
}

/* -------------------- main -------------------- */
export default function DogServicesPricing() {
  var navigate = useNavigate();
  var ctx = useContext(StateContext);
  var serviceDetails = ctx && ctx.serviceDetails ? ctx.serviceDetails : {};
  var catalog = useMemo(() => normalizeCatalog(serviceDetails), [serviceDetails]);

  function svc(name) {
    var key = String(name).toLowerCase();
    if (Object.prototype.hasOwnProperty.call(catalog, key)) return catalog[key];
    for (var alt in catalog) {
      if (!Object.prototype.hasOwnProperty.call(catalog, alt)) continue;
      if (alt.indexOf(key) !== -1 || key.indexOf(alt) !== -1) return catalog[alt];
    }
    return null;
  }

  var daycare = svc("daycare");
  var hotel = svc("hotel");
  var grooming = svc("grooming");
  var training = svc("training");
  var club = svc("pawsible club");
  var plus = svc("pawsible plus");
  var bundle10 = svc("daycare 10-pack");
  var bundle20 = svc("daycare 20-pack");

  return (
    <div className="services-background">
      <div className="container">
        <BackButton />
        <div className="services-container">
          <img className="service-page-icon" src={trainingPageIcon} alt="" />
          <header className="pricing-header">
            <h2 className="pricing-title">Discover Pawsible: Where Every Service Has Purpose</h2>
            <p className="pricing-subtitle">
              Behind every groom, daycare, and training is one purpose: a happier, well-balanced pup.
            </p>
          </header>

          {/* Membership Section */}
          <SectionCard title="Pawsible Memberships">
            <MembershipPriceChips
              tiers={{ club: club, plus: plus }}
              onClick={(key) => {
                navigate("/store/membership");
                window.scrollTo(0, 0);
              }}
            />
            <MembershipBenefitMatrix />
          </SectionCard>

          {/* Daycare & Hotel */}
          <SectionCard title="Daycare & Hotel">
            <div className="daycare-boarding-grid">
              {daycare && (
                <div className="service-card">
                  <div className="service-name">Daycare</div>
                  <div className="service-price">{currency(daycare.price)}</div>
                  <p className="service-desc">{daycare.description}</p>
                </div>
              )}

              {/* Bundle Pricing */}
              <div className="bundle-section">
                <div className="bundle-grid">

                  {bundle10 && (
                    <div
                      className="service-card price-bundle-card clickable"
                      onClick={() => {
                        navigate("/store/services/daycare");
                        window.scrollTo(0, 0);
                      }}
                    >
                      <div className="service-name">{bundle10.title}</div>
                      <div className="service-price">{currency(bundle10.price)}</div>
                    </div>
                  )}

                  {bundle20 && (
                    <div
                      className="service-card price-bundle-card clickable"
                      onClick={() => {
                        navigate("/store/services/daycare");
                        window.scrollTo(0, 0);
                      }}
                    >
                      <div className="service-name">{bundle20.title}</div>
                      <div className="service-price yellow">{currency(bundle20.price)}</div>
                    </div>
                  )}

                </div>
              </div>

              {hotel && (
                <div className="service-card">
                  <div className="service-name">Hotel</div>
                  <div className="service-price">{currency(hotel.price)}</div>
                  <p className="service-desc">{hotel.description}</p>
                </div>
              )}
            </div>
          </SectionCard>

          {/* Grooming */}
          {grooming && (
            <SectionCard title="Grooming">
              <div className="grooming-responsive">
                <div className="grooming-table-wrapper">
                  <table className="grooming-table">
                    <thead>
                      <tr>
                        <th>Size</th>
                        <th>Nail</th>
                        <th>Bath</th>
                        <th>Touch-up</th>
                        <th>Full Groom</th>
                        <th>Teeth Cleaning</th>
                      </tr>
                    </thead>
                    <tbody>
                      {["small", "medium", "large", "x-large"].map(size => {
                        var gp = grooming.additionalPrices && grooming.additionalPrices[size];
                        if (!gp) return null;
                        return (
                          <tr key={size}>
                            <td>{size}</td>
                            <td>{currency(gp.nail)}</td>
                            <td>{currency(gp.bath)}</td>
                            <td>{currency(gp.touchup)}</td>
                            <td>{currency(gp.grooming)}</td>
                            <td>{currency(gp.teeth)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <GroomingVertical priceBySize={grooming.additionalPrices || {}} />
              </div>
            </SectionCard>
          )}

          {/* Training */}
          {training && (
            <SectionCard title="Training">
              <div className="training-table-wrapper">
                <table className="training-table">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Group</th>
                      <th>Private</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(training.additionalPrices || {}).map(type => {
                      var tp = training.additionalPrices[type];
                      return (
                        <tr key={type}>
                          <td>{type.charAt(0).toUpperCase() + type.slice(1)}</td>
                          <td>{tp && tp.group ? currency(tp.group) : "—"}</td>
                          <td>{tp && tp.private ? currency(tp.private) : "—"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </SectionCard>
          )}
        </div>
      </div>

      <section className='sign-up-section'>
        <LetsGetStarted />
      </section>
      <Footer />
    </div>
  );
}
